{
  "status": "สถานะ: {{value}}"
}
